<template>
  <transition name="component-fade" mode="out-in">
    <slot></slot>
  </transition>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped src="./style.scss"></style>
